export const kanbanColumns = [
	{ value: 'pending', label: 'Pending' },
	{ value: 'accepted', label: 'Accepted' },
	{ value: 'in_progress', label: 'In Progress' },
	{ value: 'completed', label: 'Completed' },
];

export const cardStatuses = [
	{ title: 'Pending', propValue: 'PENDING', propKey: 'pending', timeProp: 'lastDatePending' },
	{ title: 'Accepted', propValue: 'ACCEPTED', propKey: 'accepted', timeProp: 'lastDateAccepted' },
	{ title: 'Cooked', propValue: 'COOKED', propKey: 'cooked', timeProp: 'lastDateCooked' },
	{
		title: 'Pickup',
		propValue: 'ACCEPTED_TO_PICK_UP',
		propKey: 'accepted_to_pick_up',
		timeProp: 'lastDateAcceptedToPickUp',
	},
	{
		title: 'In Restaurant',
		propValue: 'IN_RESTAURANT',
		propKey: 'in_restaurant',
		timeProp: 'lastDateInRestaurant',
	},
	{ title: 'Collected', propValue: 'COLLECTED', propKey: 'collected', timeProp: 'lastDateCollected' },
	{ title: 'Delivered', propValue: 'DELIVERED', propKey: 'delivered', timeProp: 'lastDateDelivered' },
];
